import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerNote} from '../entity/partnerNote.model';
import {PartnerSummaryConverter} from '../../../../common/api/converter/partnerSummary.converter';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PartnerNoteConverter extends HttpModelConverter<PartnerNote> {

    constructor(private partnerSummaryConverter: PartnerSummaryConverter,
                private userSummaryConverter: UserSummaryConverter) {
        super();
    }
    protected createInstance(): PartnerNote {
        return new PartnerNote();
    }

    protected enrichObject(result: PartnerNote, src: PartnerNote) {
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.createdBy = this.userSummaryConverter.convert(src.createdBy);
    }
}
